import Vue from "vue";
import VueRouter from "vue-router";
// import Main from '../views/Main';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    component: () => import("../views/Main"),
    redirect: "/home", // 默认显示的子路由
    children: [
      {
        path: "/home", //首页是默认子路由，所谓为空
        name: "home",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "名医谷商城",
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: "/category",
        name: "Category",
        component: () => import("../views/Category.vue"),
        meta: {
          title: "分类",
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: "/cart",
        name: "Cart",
        component: () => import("../views/Cart.vue"),
        meta: {
          title: "购物车"
          // keepAlive: true, // 需要被缓存
        }
      },
      {
        path: "/invite",
        name: "Invite",
        component: () => import("../views/Invite.vue"),
        meta: {
          title: "邀请好友",
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: "/user",
        name: "User",
        component: () => import("../views/User.vue"),
        meta: {
          title: "我的"
          // keepAlive: true, // 需要被缓存
          // requiresAuth:true
        }
      }
    ]
  },

  {
    path: "/tools/area-sql",
    name: "AreaDataExport",
    component: () => import("../views/tools/AreaDataExport.vue"),
    meta: { title: "行政区SQL导出" }
  },

  {
    path: "/goodsList",
    name: "GoodsList",
    component: () => import("../views/goods/GoodsList.vue"),
    meta: { title: "商品列表" }
  },
  {
    path: "/goodsDetails",
    name: "GoodsDetails",
    component: () => import("../views/goods/GoodsDetails.vue"),
    meta: { title: "商品详情" }
  },
  {
    path: "/franchiseArea",
    name: "FranchiseArea",
    component: () => import("../views/goods/FranchiseArea.vue"),
    meta: { title: "加盟专区", keepAlive: true }
  },
  {
    path: "/welfareArea",
    name: "WelfareArea",
    component: () => import("../views/goods/WelfareArea.vue"),
    meta: {
      keepAlive: true
      // title: "特价专区"
    }
  },
  {
    path: "/miaoshaArea",
    name: "MiaoshaArea",
    component: () => import("../views/goods/MiaoshaArea.vue"),
    meta: { title: "限时秒杀" }
  },
  {
    path: "/zhunongArea",
    name: "ZhunongArea",
    component: () => import("../views/goods/ZhunongArea.vue"),
    meta: { title: "助农行动" }
  },
  {
    path: "/orderSubmit",
    name: "OrderSubmit",
    component: () => import("../views/goods/OrderSubmit.vue"),
    meta: { title: "提交订单", refresh: false, keepAlive: true }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/Login.vue"),
    meta: { title: "登录" }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/login/Register.vue"),
    meta: { title: "注册" }
  },
  {
    path: "/findPwd",
    name: "FindPwd",
    component: () => import("../views/login/FindPwd.vue"),
    meta: { title: "找回密码" }
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("../views/ucenter/Agreement.vue"),
    meta: { title: "用户协议" }
  },
  {
    path: "/withdrawal",
    name: "Withdrawal",
    component: () => import("../views/ucenter/Withdrawal.vue"),
    meta: { title: "提现" }
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () => import("../views/ucenter/AboutUs.vue"),
    meta: { title: "关于我们" }
  },
  {
    path: "/addressManage",
    name: "AddressManage",
    component: () => import("../views/ucenter/AddressManage.vue"),
    meta: { title: "地址管理", isBack: true }
  },
  {
    path: "/addressAdd",
    name: "AddressAdd",
    component: () => import("../views/ucenter/AddressAdd.vue"),
    meta: { title: "添加地址" }
  },
  {
    path: "/addressEdit",
    name: "AddressEdit",
    component: () => import("../views/ucenter/AddressEdit.vue"),
    meta: { title: "修改地址" }
  },
  {
    path: "/myCollection",
    name: "MyCollection",
    component: () => import("../views/ucenter/MyCollection.vue"),
    meta: { title: "我的收藏" }
  },
  {
    path: "/contactService",
    name: "ContactService",
    component: () => import("../views/ucenter/ContactService.vue"),
    meta: { title: "联系客服" }
  },
  {
    path: "/accountManage",
    name: "AccountManage",
    component: () => import("../views/ucenter/AccountManage.vue"),
    meta: { title: "账户管理" }
  },
  {
    path: "/bindAlipay",
    name: "BindAlipay",
    component: () => import("../views/ucenter/BindAlipay.vue"),
    meta: { title: "绑定支付宝" }
  },
  {
    path: "/bindBankCard",
    name: "BindBankCard",
    component: () => import("../views/ucenter/BindBankCard.vue"),
    meta: { title: "绑定银行卡" }
  },
  {
    path: "/setUp",
    name: "SetUp",
    component: () => import("../views/ucenter/SetUp.vue"),
    meta: { title: "设置" }
  },
  {
    path: "/changeParent",
    name: "changeParent",
    component: () => import("../views/ucenter/changeParent.vue"),
    meta: { title: "更改昵称" }
  },
  {
    path: "/changeName",
    name: "ChangeName",
    component: () => import("../views/ucenter/ChangeName.vue"),
    meta: { title: "更改昵称" }
  },
  {
    path: "/changePhone",
    name: "ChangePhone",
    component: () => import("../views/ucenter/ChangePhone.vue"),
    meta: { title: "更改手机号" }
  },
  {
    path: "/changeNewPhone",
    name: "changeNewPhone",
    component: () => import("../views/ucenter/changeNewPhone.vue"),
    meta: { title: "修改手机号" }
  },
  {
    path: "/changePwd",
    name: "ChangePwd",
    component: () => import("../views/ucenter/ChangePwd.vue"),
    meta: { title: "修改密码" }
  },
  {
    path: "/orderList",
    name: "OrderList",
    component: () => import("../views/ucenter/OrderList.vue"),
    meta: {
      title: "我的订单"
      // refresh: false, keepAlive: true
    }
  },
  {
    path: "/orderDetails",
    name: "OrderDetails",
    component: () => import("../views/ucenter/OrderDetails.vue"),
    meta: { title: "订单详情" }
  },
  {
    path: "/writeOffOrder",
    name: "WriteOffOrder",
    component: () => import("../views/ucenter/WriteOffOrder.vue"),
    meta: { title: "订单核销" }
  },
  {
    path: "/viewOrderDetails",
    name: "viewOrderDetails",
    component: () => import("../views/ucenter/ViewOrderDetails.vue"),
    meta: { title: "订单详情" }
  },
  {
    path: "/message",
    name: "Message",
    component: () => import("../views/ucenter/Message.vue"),
    meta: { title: "消息提醒" }
  },
  {
    path: "/commissionList",
    name: "CommissionList",
    component: () => import("../views/ucenter/CommissionList.vue"),
    meta: { title: "佣金记录" }
  },
  {
    path: "/commissionList2",
    name: "CommissionList2",
    component: () => import("../views/ucenter/CommissionList2.vue"),
    meta: { title: "佣金记录" }
  },
  {
    path: "/commissionList3",
    name: "CommissionList3",
    component: () => import("../views/ucenter/CommissionList3.vue"),
    meta: { title: "佣金记录" }
  },
  {
    path: "/memberDetails",
    name: "MemberDetails",
    component: () => import("../views/ucenter/MemberDetails.vue"),
    meta: { title: "佣金详情" }
  },
  {
    path: "/memberAreaDetails",
    name: "MemberAreaDetails",
    component: () => import("../views/ucenter/MemberAreaDetails.vue"),
    meta: { title: "佣金详情", keepAlive: true,refresh: false }
  },
  {
    path: "/memberList",
    name: "MemberList",
    component: () => import("../views/ucenter/MemberList.vue"),
    meta: { title: "我的用户" }
  },
  {
    path: "/supportFund",
    name: "SupportFund",
    component: () => import("../views/ucenter/SupportFund.vue"),
    meta: { title: "帮扶基金" }
  },
    {
    path: "/woffIntegral",
    name: "WoffIntegral",
    component: () => import("../views/ucenter/WoffIntegral.vue"),
    meta: { title: "核销记录" }
  },
      {
    path: "/teamSumCommission",
    name: "TeamSumCommission",
    component: () => import("../views/ucenter/TeamSumCommission.vue"),
    meta: { title: "营销记录" }
  },
  {
    path: "/entryForm",
    name: "EntryForm",
    component: () => import("../views/ucenter/EntryForm.vue"),
    meta: { title: "商家入驻" }
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: () => import("../views/ucenter/Feedback.vue"),
    meta: { title: "意见反馈" }
  },
  {
    path: "/faqList",
    name: "FaqList",
    component: () => import("../views/ucenter/FaqList.vue"),
    meta: { title: "常见问题" }
  },
  {
    path: "/shopList",
    name: "ShopList",
    component: () => import("../views/ucenter/ShopList.vue"),
    meta: { title: "选择门店" }
  },
  {
    path: "/articleList",
    name: "ArticleList",
    component: () => import("../views/ucenter/ArticleList.vue")
  },
  {
    path: "/articleDetails",
    name: "ArticleDetails",
    component: () => import("../views/ucenter/ArticleDetails.vue")
  },
  {
    path: "/searchList",
    name: "searchList",
    component: () => import("../views/product/searchList.vue")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search/Index.vue"),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: "/cartChild",
    name: "CartChild",
    component: () => import("../views/cart/Index.vue"),
    meta: {
      title: "购物车"
      // keepAlive: true, // 需要被缓存
    }
  },
  {
    path: "/shop",
    name: "Shop",
    component: () => import("../views/goods/Shop.vue"),
    meta: {
      title: "店铺"
      // keepAlive: true, // 需要被缓存
    }
  },
  {
    path: "/shopInfo",
    name: "ShopInfo",
    component: () => import("../views/goods/ShopInfo.vue"),
    meta: {
      title: "店铺",
      keepAlive: true // 需要被缓存
    }
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  // {
  //   path: "/about",
  //   name: "About",
  //  // route level code-splitting
  //  // this generates a separate chunk (about.[hash].js) for this route
  //  // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  {
    path: "/WithdrawalList",
    name: "WithdrawalList",
    component: () => import("../views/ucenter/WithdrawalList.vue"),
    meta: { title: "提现明细" }
  },
  {
    path: "/Orderfinish",
    name: "Orderfinish",
    component: () => import("../views/orderfinish/index.vue"),
    meta: { title: "提交订单" }
  },
  {
    path: "/ShopNew",
    name: "ShopNew",
    component: () => import("../views/goods/ShopNew.vue"),
    meta: { title: "商铺首页" }
  },
  {
    path: "/ShopaArticleList",
    name: "ShopaArticleList",
    component: () => import("../views/Shop/ArticleList.vue"),
    meta: { title: "文章列表" }
  },
  {
    path: "/ShopaArticleInfo",
    name: "ShopaArticleInfo",
    component: () => import("../views/Shop/ArticleInfo.vue"),
    meta: { title: "文章内容" }
  },
  {
    path: "/ArticleInfo",
    name: "ArticleInfo",
    component: () => import("../views/ucenter/ArticleInfo.vue"),
    meta: { title: "文章内容" }
  },
  {
    path: "/coupon",
    name: "Coupon",
    component: () => import("../views/ucenter/Coupon.vue"),
    meta: { title: "优惠卷" }
  },
  {
    path: "/jifenDetails",
    name: "JifenDetails",
    component: () => import("../views/ucenter/JifenDetails.vue"),
    meta: { title: "积分明细" }
  },
  {
    path: "/jifenGive",
    name: "JifenGive",
    component: () => import("../views/ucenter/JifenGive.vue"),
    meta: { title: "转赠明细" }
  },
  {
    path: "/jifenGiveForm",
    name: "JifenGiveForm",
    component: () => import("../views/ucenter/JifenGiveForm.vue"),
    meta: { title: "积分转赠" }
  },
  {
    path: '/yeGiveForm',
    name: 'YeGiveForm',
    component: () => import('../views/ucenter/YeGiveForm.vue'),
    meta: { title: "余额转积分" }
  },
  {
    path: '/yeGiveForm2',
    name: 'YeGiveForm2',
    component: () => import('../views/ucenter/YeGiveForm2.vue'),
    meta: { title: "积分转余额" }
  },
  {
    path: '/yeGive',
    name: 'YeGive',
    component: () => import('../views/ucenter/YeGive.vue'),
    meta: { title: "转入转出明细" }
    
  },
  {
    path: "/writeOff",
    name: "WriteOff",
    component: () => import("../views/WriteOff.vue"),
    meta: { title: "核销" }
  },
  {
    path:"/signIn",
    name:"SignIn",
    component:()=>import("../views/signIn"),
    meta: { 
      title: "签到中心",
      requiresAuth: true
   }
  },
  {
    path:"/commissionTeam",
    name:"CommissionTeam",
    component:()=>import("../views/commission/Team"),
    meta: { 
      title: "团队奖",
      requiresAuth: true
   }
  },
  {
    path:"/boleCommissions",
    name:"BoleCommissions",
    component:()=>import("../views/ucenter/BoleCommissions"),
    meta: { 
      title: "伯乐奖",
      requiresAuth: true
   }
  },
  {
    path:"/commissionRegion",
    name:"CommissionRegion",
    component:()=>import("../views/commission/Region"),
    meta: { 
      title: "区域奖",
      requiresAuth: true
   }
  },
  {
    path:"/commissionReserveIntegral",
    name:"CommissionReserveIntegral",
    component:()=>import("../views/commission/ReserveIntegral"),
    meta: { 
      title: "健康豆记录",
      requiresAuth: true
   }
  },
  {
    path:"/recommendList",
    name:"Recommend",
    component:()=>import("../views/recommend/index"),
    meta: { 
      title: "推荐列表"
   }
  },
  {
    path: "/statuShelve",
    name: "StatuShelve",
    component: () => import("../views/status/shelve.vue"),
    meta: { title: "产品状态" }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
    meta: { title: "页面错误" }
  },
  { path: "*", redirect: "/404", hidden: true }
];

const router = new VueRouter({
  routes,
  mode: "history", //去掉url中的#
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; //游览器返回记住位置
    } else {
      return { x: 0, y: 0 }; //滚动到顶
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 路由守卫中不做授权处理，避免无限循环
  // 授权逻辑由各个页面在需要时单独调用，weixin.js 中已有防重复机制

  // if (to.matched.some(record => record.meta.requiresAuth)) {
  //   var token =localStorage.getItem("token");
  //   if (token == null) { //判断是否获取accessToken
  //     next({
  //       path: '/login', //登录跳转
  //       query: { returnUrl: to.fullPath }
  //     })

  //   }
  //   else {
  //     next();
  //   }
  // }
  // else {
  //   next();
  // }

  // if(to.matched.length === 0){
  //     console.log(from.path,"dddddddddddddd");
  //     from.path ? next({name: from.name}) : next('/404')
  // }else{
  //     next()
  // }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js